<template>
    <div class="Details Services">
        <Navbar title="Yajobici" />
        <div class="container-fluid p-0">
           <div style="margin-top: 120px !important">

              <!-- Header (start) -->
              <div class=" page-header mb-5" style="background-color: #61C7F2 !important">
                <div class="container pt-4 pb-4">
                    <h2 class="text-white mb-3 animated slideInDown">{{ categorieName }}</h2>
                </div>
              </div>
              <!-- Header (End) -->



              <!-- Sous_cat (Start) -->
                <div class="container-fluid features overflow-hidden py-5 ">
                    <div class="container px-5">
                        <div class="section-title text-center mb-5 wow fadeInUp" data-wow-delay="0.1s">
                            <div class="sub-style">
                                <h5 class="sub-title text-primary px-3">Explorer vos catégories</h5>
                            </div>
                            <p class="mb-0">Choisissez l'une des catégories ci-dessous pour trouver le prestataire dont vous avez besoin.</p>
                        </div>

                        <div v-if="isLoading" class="row">
                            <div class="col-md-12 text-center">
                                <span style="color: #F7A51B !important">
                                    Affichage des catégories en cours ...
                                </span>
                            </div>
                        </div>

                        <div v-else class="row g-4 text-center containe px-5">
                            <div v-if="subCategories.length == 0" class="text-center py-4">
                                <span class="text-danger">Il n'y a pas de categories pour ce domaine :)</span>
                            </div>
                            <div v-else v-for="sc in subCategories" :key="sc.id" class="col-12 col-sm-6 col-md-4 col-lg-3 wow fadeInUp" data-wow-delay="0.1s">
                                <router-link :to="{ name: 'categorieService', params: { subcatId: sc.id, subcatName: sc.libelle }}"  
                                class="feature-item text-center p-4 card">
                                <center>
                                    <div class="feature-icon p-3 mb-4">
                                        <i class="fa fa-search fa-3x"></i>
                                    </div>
                                </center>
                                    <div class="feature-content d-flex flex-column">
                                        <h5 class="mb-3" style="font-size: 15px;">{{ sc.libelle }}</h5>
                                        <a class="btn btn-secondary rounded-pill mb-3" href="#">
                                            J'explore +
                                        </a>
                                    </div>
                                </router-link>
                            </div>
                        </div>

                    </div>
                </div>
              <!-- Sous_cat (End) -->
              
           </div> 


            <!-- Footer Start -->
            <Footer/>
            <!-- Footer End -->
        </div>
    </div>  
</template>


<script>
    import Navbar from "../../components/Navbar.vue";
    import Footer from "../../components/Footer.vue";
    
    export default {
        name: 'DetailService',
        components: {
            Navbar,
            Footer,
        },
        data() {
            return {
                subCategories: [],
                categorieName: "",
                isLoading: false
            };
        },
        mounted(){
            this.getSousCategorie(this.$route.params.categorieId);
            this.categorieName = this.$route.params.categorieName;
            //console.log("FDFDS ", this.$route.params.categorieId);
        },
        methods: {
            async getSousCategorie(catId) {
                this.isLoading = true;
                await this.$store.dispatch("staticdata/fetchSubCategorie", catId)
                .then(
                    (response) => {
                        this.isLoading = false;
                        this.subCategories = response.data;
                    },
                    (error) => {
                        this.isLoading = false;
                        console.log("error--- ", error);
                    }
                );
            }
        }
    }
</script>